import React from "react";
import Navbar from "../Navbar/Navbar";
import "./LandingPage.css";
import Image1 from "../../assets/image1.png";
import Image2 from "../../assets/image2.png";
import Image3 from "../../assets/image3.png";
import Image4 from "../../assets/image4.png";
import Image5 from "../../assets/image5.png";
import Image6 from "../../assets/image6.png";
import Image7 from "../../assets/image7.png";
import Image8 from "../../assets/image8.png";
import Image9 from "../../assets/image9.png";
import Image10 from "../../assets/image10.png";
import Image11 from "../../assets/image11.png";
import Image12 from "../../assets/image12.png";
import Image13 from "../../assets/image13.png";
import Image14 from "../../assets/image14.png";
import Image15 from "../../assets/image15.png";
import Image16 from "../../assets/image16.png";
import Image17 from "../../assets/image17.png";
import Image18 from "../../assets/image18.png";
import Image19 from "../../assets/image19.png";
import Team1 from "../../assets/team1.png";
import Team2 from "../../assets/team2.png";
import Team3 from "../../assets/team3.png";
import Team4 from "../../assets/team4.png";
import AboutImage from "../../assets/about-image.png";
import Faq from "react-faq-component";
import { BsTwitter } from "react-icons/bs";
import Footer from "../Footer/Footer";

const data = {
  rows: [
    {
      title: "When is launch?",
      content: `Launch will be a fair and semi stealth launch. We’ve noticed that the overhyped launches does nothing but cause high gas wars and people missing out that were truly a fan of the art. So, launch will happen with short notice - this will be announced in our discord (link to it)`,
    },
    {
      title: "How much is it?",
      content: "0.035 ETH + gas fees",
    },
    {
      title: "When does $ROOT launch?",
      content: `Within days of the end of the collection sale`,
    },
    {
      title:
        "What else is in the roadmap? Seems like there isn't much happening besides the token?",
      content: `We prefer to not make things up to just entice people - which we all know projects do. So - we are trialing a cool concept, one where we integrate with a voting mechanism where future features are decided by holders of Bears and $ROOT. More on our discord soon!`,
    },
    {
      title: "So....how will any value be attached to $ROOT?",
      content: `IDK`,
    },
  ],
};

const styles = {
  bgColor: "#412201",
  rowTitleColor: "white",
  rowContentColor: "rgba(255,255,255,.5)",
  arrowColor: "#AB6825",
  rowTitleTextSize: "35px",
  rowContentTextSize: "25px",
};

const LandingPage = () => {
  return (
    <div className="landing-container lo-res">
      <div className="landing-hero">
        <Navbar />
        <div className="hero-text">
          <h1 className="gradient">BearX Has</h1>
          <h1 className="gradient">Arrived</h1>
          <p>
            This project is made for fun, and will be driven by it. The
            community comes first, always and forever. BearX
          </p>
        </div>
      </div>
      <div className="landing-gallery">
        <img src={Image1} alt="NFT 1" />
        <img src={Image2} alt="NFT 2" />
        <img src={Image3} alt="NFT 3" />
        <img src={Image4} alt="NFT 4" />
        <img src={Image5} alt="NFT 5" />
        <img src={Image6} alt="NFT 6" />
        <img src={Image7} alt="NFT 7" />
        <img src={Image8} alt="NFT 8" />
        <img src={Image9} alt="NFT 9" />
        <img src={Image10} alt="NFT 10" />
        <img src={Image11} alt="NFT 11" />
        <img src={Image12} alt="NFT 12" />
        <img src={Image13} alt="NFT 13" />
        <img src={Image14} alt="NFT 14" />
        <img src={Image15} alt="NFT 15" />
        <img src={Image16} alt="NFT 16" />
        <img src={Image17} alt="NFT 17" />
        <img src={Image18} alt="NFT 18" />
      </div>
      <div className="landing-about" id="about">
        <div className="landing-about-top">
          <div className="landing-about-top-info">
            <h1 className="gradient2"> What Are the launch details?</h1>
            <p>
              Launch will be a fair. Each mint is completely random, with no
              order at all. No one, not even the founding team knows what Bear
              is being minted next. We’ve also noticed that the overhyped
              launches creates nothing but crazy gas wars and people missing out
              that were truly a fan of the art. So, launch will happen with
              short notice – this will be announced in our discord
            </p>
          </div>
          <img src={AboutImage} alt="About" />
        </div>
        <div className="landing-about-bottom">
          <img src={Image19} alt="Mint" />
          <div className="landing-about-bottom-info">
            <p>
              After being over thrown by degenerate apes during various periods
              of this era, the bears have reassembled and inhabited multiple
              planets to rebuild the species. Due to this, only 5,000 survived,
              with most having to adopt a range of skills to survive in space.
            </p>
            <h1>-/3,700 AVAILABLE</h1>
            <div className="landing-about-button mint">MINT NOW</div>
          </div>
        </div>
      </div>
      <div className="landing-faq" id="faq">
        <div className="landing-faq-title">
          <h1 className="gradient2">FREQUENTLY</h1>
          <h1 className="gradient2">ASKED</h1>
          <h1 className="gradient2">QUESTIONS</h1>
        </div>
        <Faq data={data} styles={styles} />
      </div>
      <div className="landing-team" id="team">
        <h1 className="gradient2">MEET OUR TEAM</h1>
        <div className="landing-team-profiles">
          <div className="landing-team-profile">
            <img src={Team1} alt="Akeem" />
            <p>
              @Akeem <BsTwitter />
            </p>
            <h2 className="gradient2">CREATOR</h2>
          </div>
          <div className="landing-team-profile">
            <img src={Team2} alt="Obelisxx" />
            <p>
              @Obelisxx <BsTwitter />
            </p>
            <h2 className="gradient2">ARTIST</h2>
          </div>
          <div className="landing-team-profile">
            <img src={Team3} alt="Bayliss" />
            <p>
              @Bayliss <BsTwitter />
            </p>
            <h2 className="gradient2">DEVELOPER</h2>
          </div>
          <div className="landing-team-profile">
            <img src={Team4} alt="Chamso" />
            <p>
              @Chamso <BsTwitter />
            </p>
            <h2 className="gradient2">CONCEPT ARTIST</h2>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;
